/* eslint-disable react/forbid-prop-types */
import React from 'react';
import * as XLSX from 'xlsx'; 
import { Row, Button, Badge } from 'reactstrap';
import PropTypes from 'prop-types';
import { setCurrencyFormat } from '../../../../utils/helpers';
import ResizableDataTable from '../../../Tables/ResizableTable/components/ResizableReactTable';


const ProfitTable = ({ data, tableHeaderData, fileName, vendor }) => {


    const skuWise = {};
    data.forEach((item) => {
        const { netMargin, netProfit, fbaFeesEst, cost, grossRevenue, sellingFeesEst, sku } = item;

        if (skuWise?.[sku]) {
            const updatedItem = { ...skuWise[sku] }
            updatedItem.netMargin += Number(netMargin);
            updatedItem.netProfit += Number(netProfit);
            updatedItem.fbaFeesEst += Number(fbaFeesEst);
            updatedItem.cost += Number(cost);
            updatedItem.grossRevenue += Number(grossRevenue);
            updatedItem.sellingFeesEst += Number(sellingFeesEst);
            updatedItem.numberOfItem += 1
            skuWise[sku] = updatedItem
        } else {
            skuWise[sku] = {
                ...item, netMargin: Number(netMargin),
                netProfit: Number(netProfit),
                fbaFeesEst: Number(fbaFeesEst),
                cost: Number(cost),
                grossRevenue: Number(grossRevenue),
                sellingFeesEst: Number(sellingFeesEst),
                numberOfItem: 1
            }
        }
    });

    const excelData = Object.values(skuWise).map((item) => {
        const updated = { ...item };
        updated.netMargin = `${Number(updated.netMargin / updated.numberOfItem).toFixed(2)}%`;


        if (vendor === 'amazon') {
            updated.fbaFeesEst = setCurrencyFormat(Number(updated.fbaFeesEst).toFixed(2), true);
            updated.sellingFeesEst = setCurrencyFormat(Number(updated.sellingFeesEst).toFixed(2), true);
            updated.netProfit = setCurrencyFormat(Number(updated.netProfit).toFixed(2), true);
        }
        else if (vendor === 'shopify') {
            const shippingEst = Number((updated.grossRevenue * 25) / 100)
            updated.shippingEst = setCurrencyFormat(shippingEst.toFixed(2), true);
            const netProf = Number(updated.grossRevenue) - Number(shippingEst) - Number(updated.cost)
            updated.netProfit = setCurrencyFormat(netProf.toFixed(2), true);
        } else {

            const brokerEst = Number((updated.grossRevenue * 5) / 100)
            updated.brokerEst = setCurrencyFormat(brokerEst.toFixed(2), true);
            const netProf = Number(updated.grossRevenue) - Number(brokerEst) - Number(updated.cost)
            updated.netProfit = setCurrencyFormat(netProf.toFixed(2), true);

        }

        updated.cost = setCurrencyFormat(Number(updated.cost).toFixed(2), true);
        updated.grossRevenue = setCurrencyFormat(Number(updated.grossRevenue).toFixed(2), true);

        return updated
    });

    const handleDownload = () => {
        if (!data.length) return;

        // Create a new workbook
        const wb = XLSX.utils.book_new();
        
        // Create headers array from tableHeaderData
        const headers = tableHeaderData?.map(col => col.Header) || [];
        
        // Create data array with only the fields specified in tableHeaderData
        const worksheetData = excelData?.map(row => {
            const filteredRow = {};
            tableHeaderData?.forEach(col => {
                filteredRow[col.Header] = row[col.accessor];
            });
            return filteredRow;
        }) || [];
        
        // Convert data to worksheet format with proper headers
        const ws = XLSX.utils.json_to_sheet(worksheetData, { header: headers });
        
        // Add worksheet to workbook
        XLSX.utils.book_append_sheet(wb, ws, 'report');
        
        // Write the file
        XLSX.writeFile(wb, `${fileName}.xlsx`);
    };


    return (
        <Row style={{ position: 'relative' }} className="profit-table">
            <div className="ExcelTable">
                <Button 
                    disabled={!data.length}
                    className="download-monthly-sub-order-report btn-primary btn btn-sm"
                    onClick={handleDownload}
                >
                    Download
                </Button>
            </div>
            <ResizableDataTable reactTableData={{ tableHeaderData }} data={excelData} />
        </Row>
    )
}

ProfitTable.propTypes = {
    data: PropTypes.array.isRequired,
    tableHeaderData: PropTypes.array.isRequired,
    fileName: PropTypes.string,
    vendor: PropTypes.number.isRequired
};

ProfitTable.defaultProps = {
    fileName: "Profit Report",
}


export default ProfitTable;